import React, { ReactElement } from 'react';
import { ConnectedUserIntegrations } from '../container';
import { SAAS_INTEGRATION_TYPE } from '../../../../../constants';

export const Saas = (): ReactElement => {
  return <ConnectedUserIntegrations integrationType={SAAS_INTEGRATION_TYPE} />;
};
